import '../assets/NcIconSvgWrapper-oui2KPBT.css';
import a, { useCssVars as o } from "vue";
import u from "dompurify";
import { n as p } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const r = {
  name: "NcIconSvgWrapper",
  props: {
    /**
     * Set if the icon should be used as inline content e.g. within text.
     * By default the icon is made a block element for use inside `icon`-slots.
     */
    inline: {
      type: Boolean,
      default: !1
    },
    /**
     * Raw SVG string to render
     */
    svg: {
      type: String,
      default: ""
    },
    /**
     * Label of the icon, used in aria-label
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Raw SVG path to render. Takes precedence over the SVG string in the `svg` prop.
     */
    path: {
      type: String,
      default: ""
    },
    /**
     * Size of the icon to show. Only use if not using within an icon slot.
     * Defaults to 20px which is the Nextcloud icon size for all icon slots.
     * @default 20
     */
    size: {
      type: [Number, String],
      default: 20,
      validator: (t) => typeof t == "number" || t === "auto"
    }
  },
  computed: {
    /**
     * Icon size used in CSS
     */
    iconSize() {
      return typeof this.size == "number" ? "".concat(this.size, "px") : this.size;
    },
    cleanSvg() {
      if (!this.svg || this.path)
        return;
      const t = u.sanitize(this.svg), e = new DOMParser().parseFromString(t, "image/svg+xml");
      return e.querySelector("parsererror") ? (a.util.warn("SVG is not valid"), "") : (e.documentElement.id && e.documentElement.removeAttribute("id"), e.documentElement.outerHTML);
    },
    attributes() {
      return {
        class: ["icon-vue", { "icon-vue--inline": this.inline }],
        role: "img",
        "aria-hidden": this.name ? void 0 : !0,
        "aria-label": this.name || void 0
      };
    }
  }
}, s = () => {
  o((t, e) => ({
    "758c7a6a": t.iconSize
  }));
}, i = r.setup;
r.setup = i ? (t, e) => (s(), i(t, e)) : s;
const l = r;
var c = function() {
  var e = this, n = e._self._c;
  return e.cleanSvg ? n("span", e._b({ domProps: { innerHTML: e._s(e.cleanSvg) } }, "span", e.attributes, !1)) : n("span", e._b({}, "span", e.attributes, !1), [n("svg", { attrs: { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" } }, [n("path", { attrs: { d: e.path } })])]);
}, m = [], _ = /* @__PURE__ */ p(
  l,
  c,
  m,
  !1,
  null,
  "74df2152",
  null,
  null
);
const g = _.exports;
export {
  g as N
};
